<h1 mat-dialog-title
    class="title draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    {{roleName}} Role Membership for {{entityName}}
</h1>

<div mat-dialog-content class="body" cdkTrapFocus>
    <div class="members-table-wrapper">
        <table #roleMemberTable mat-table [dataSource]="members" class="members-table">
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    Select
                </th>
                <td mat-cell *matCellDef="let user">
                    <mat-checkbox [(ngModel)]="user.selected" [disabled]="membersAreInherited" (change)="dirty=true"></mat-checkbox>
                </td>
            </ng-container>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let user"> {{user.member}} </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions </th>
                <td mat-cell *matCellDef="let user">
                    <button mat-icon-button
                            type="button"
                            (click)="deleteMember($event, user)"
                            (keyup.enter)="deleteMember($event, user)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
    <div *ngIf="isFolderLevel()" class="role-group-info">
        <div *ngIf="membersAreInherited">These role members are inherited from the parent folder.</div>
        <div *ngIf="!membersAreInherited">These role members are managed here.</div>
    </div>
    <div [ngClass]="isFolderLevel() ? '' : 'delete-all-btn'">
        <button mat-flat-button color="warn" (click)="deleteAllMembers()">Delete All</button>
    </div>
    <div class="add-member-form">
        <!-- reactive form may seem like overkill, but it makes auto complete easy -->
        <form matForm [formGroup]="addMemberForm" class="addMemberForm">
            <div class="add-member-control-wrapper">
                <mat-form-field appearance="outline" [floatLabel]="'always'" class="add-member-control">
                    <mat-label>Add Member or Group</mat-label>
                    <input matInput id="add-role-member-input" formControlName="user" [matAutocomplete]="addMemberAutoComplete" cdkFocusInitial>
                    <span matSuffix *ngIf="showLoadingIndicator"><mat-spinner [diameter]="25"></mat-spinner></span>
                    <mat-autocomplete #addMemberAutoComplete [panelWidth]="750" [displayWith]="displayUserName">
                        <mat-option *ngFor="let pi of pickerItems | async" [value]="pi">
                            <span title="{{pi.fullDisplay}}">{{pi.fullDisplay}}</span>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <button mat-flat-button matSuffix
                        class="add-member-btn theme-primary-btn"
                        color="primary"
                        [disabled]="!addMemberForm.dirty"
                        (click)="addMember()">
                    Add
                </button>
            </div>
        </form>
    </div>
</div>

<div mat-dialog-actions>

    <!--Re-enable this if need to restore differentiated Folder vs Site level behavior-->
    <!--
        <button *ngIf="isFolderLevel()" mat-flat-button color="primary" class="theme-primary-btn" (click)="saveSelectedMembers()" [disabled]="!dirty">Save Selections</button>
    -->

    <button id="role-dialog-close-btn" mat-flat-button class="btn-light" (click)="closeDialog()">Close</button>
</div>
